import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { setGridView } from "../../../redux/SearchSlice";
import { localStorageInstance } from "../../../utils/localStorage";

export function useWatchingViewToggle() {
  const dispatch = useDispatch();
  const gridView = useSelector((state) => state.search.gridView);

  const handleGridView = React.useCallback(() => {
    if (!gridView) {
      dispatch(setGridView());
    }

    localStorageInstance.setItem({
      key: "showGridView",
      value: true,
    });
  }, [dispatch, gridView]);

  const handleListView = React.useCallback(() => {
    if (gridView) {
      dispatch(setGridView());
    }

    localStorageInstance.setItem({
      key: "showGridView",
      value: false,
    });
  }, [dispatch, gridView]);

  return {
    gridView,
    handleGridView,
    handleListView,
  };
}
